export const SET_DATE_FILTER = 'SET_DATE_FILTER';
export const TOGGLE_DATE_FILTER = 'TOGGLE_DATE_FILTER';

export const SET_ZOO_FILTER = 'SET_ZOO_FILTER';
export const TOGGLE_ZOO_FILTER = 'TOGGLE_ZOO_FILTER';

export const SET_EVENT_FILTER = 'SET_EVENT_FILTER';
export const TOGGLE_EVENT_FILTER = 'TOGGLE_EVENT_FILTER';

export const SET_ANIMAL_FILTER = 'SET_ANIMAL_FILTER';
export const TOGGLE_ANIMAL_FILTER = 'TOGGLE_ANIMAL_FILTER';

export const SET_TIME_FILTER = 'SET_TIME_FILTER';
export const TOGGLE_TIME_FILTER = 'TOGGLE_TIME_FILTER';

export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS';

export const tagLabels = Object.freeze({
  // For event type `talk` or `unscheduledTalk`
  'keeper-pov': 'Keeper POV',
  'animal-update': 'Animal Update',
  'expert-session': 'Expert Session',
  // For event type `other` or `feeding`
  'veterinary-procedures': 'Veterinary Procedures',
  'special-feeding': 'Special Feeding',
  birthday: 'Birthday',
  'new-arrival-day': 'New Arrival Day',
  'departure-day': 'Departure Day',
  celebration: 'Celebration',
});

export const HostEventTagOptions = [
  { label: 'Keeper POV', value: 'keeper-pov' },
  { label: 'Animal Update', value: 'animal-update' },
  { label: 'Expert Session', value: 'expert-session' },
];

export const NonHostEventTagOptions = [
  { label: 'Veterinary Procedures', value: 'veterinary-procedures' },
  { label: 'Special Feeding', value: 'special-feeding' },
  { label: 'Birthday', value: 'birthday' },
  { label: 'New Arrival Day', value: 'new-arrival-day' },
  { label: 'Departure Day', value: 'departure-day' },
  { label: 'Celebration', value: 'celebration' },
];
